import { z } from 'zod';
/** ObjectId de Mongo (Pioneros). 24 chars hex. */
export const MongoObjectId = z
    .string()
    .regex(/^[0-9a-f]{24}$/i, 'Expected 24-character hex ObjectId');
/** Site ID = core.site.id (text hex 24 chars, mongo ObjectId de Pioneros). */
export const SiteId = z.string().regex(/^[0-9a-f]{24}$/i, 'Expected 24-character hex site id');
/** UUID v7 generado por el backend (sessions, llm_calls). */
export const Uuid = z.string().uuid();
// Dimensiones Marzano (P4).
export const Dim = z.enum(['recuperacion', 'comprension', 'analisis', 'transferencia']);
export const Criteria = z.enum([
    'recuperacion_factual',
    'recuperacion_procedimental',
    'comprension_integradora',
    'comprension_simbolica',
    'analisis_correspondencia',
    'analisis_clasificacion',
    'analisis_error',
    'analisis_generalizacion',
    'analisis_especificacion',
    'transferencia_decision',
    'transferencia_resolucion_problema',
    'transferencia_invencion',
    'transferencia_investigacion',
]);
// Modalidades P5 §3.2.
export const Modality = z.enum(['written', 'oral', 'mixed', 'simplified_1_3']);
// Reemplaza el vocabulario P1 "insuficiente/elemental"; sincronizado con migración 0001.
export const DictamenState = z.enum([
    'no_evidencia',
    'en_desarrollo',
    'suficiente',
    'profundo',
]);
// Sub-cohortes piloto (P9 §5.8).
export const SubCohort = z.enum(['1_3_basica', '4_8_basica', 'media']);
// Roles Marzano (P6 §5.1).
export const MarzanoRole = z.enum([
    'student',
    'teacher',
    'guardian',
    'curriculum_admin',
    'school_admin',
    'system_admin',
]);
// Fases piloto (pilot_phase_history.phase).
export const PilotPhase = z.enum(['phase_0', 'phase_1', 'phase_2', 'expansion']);
//# sourceMappingURL=primitives.js.map